import React from 'react';

import { ErrorMessage } from 'formik';
import { Sticky } from 'react-sticky';
import { withTheme } from 'styled-components'

import Box from '../Box';
import Text from '../Text';
import MdBold from '../MdBold';
import { Counter, Increment } from './Counter';

export default (SubComp) => withTheme(({
  label,
  name,
  required,
  randomID,
  hint,
  sort,
  snap,
  theme,
  hasProgess,
  preferHintRequired,
  ...props
}) => {
  const content = (
    <Box pl="0.5em">
      {label && (
        <Counter name={randomID} fontSize="1.25em">
          <MdBold is="span">{label}</MdBold>
          {sort && (props.hasDnD ? '(請拖曳選項排序先後)' : '(請點擊選項排序先後)')}
          {props.multiple && '(可複選)'}
          {required ? preferHintRequired && '(必填)' : !preferHintRequired && '(選填)'}
        </Counter>
      )}
      {hint && <Text color="gray" my="0.5em" whiteSpace="pre-wrap">{hint}</Text>}
      <ErrorMessage name={name}>
        {msg => msg && (
          <Text.error my="0.5em">{msg}</Text.error>
        )}
      </ErrorMessage>
    </Box>
  )
  return (
    <Increment name={randomID}>
      {snap ? (
        <Sticky topOffset={0} bottomOffset={-180}>
          {({ style, isSticky }) => (
            <Box
              bg="white"
              zIndex={2}
              style={{
                ...style,
                top: isSticky ? (hasProgess ? theme.headerHeight : 0) : 0,
              }}
              // transition="top 0.5s"
              py="1em"
              borderBottom="2px solid"
              borderColor={isSticky ? 'variations.gray.3' : 'transparent'}
              boxShadow
            >
              {content}
            </Box>
          )}
        </Sticky>
      ) : (
        <Box bg="white" py="1em">{content}</Box>
      )}
      <Box pb="1em">
        <SubComp name={name} {...props} />
      </Box>
    </Increment>
  )
})
